import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { SkeletonLoading } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./HotelCard.module.scss";

export const HotelCard_Loading = ({ className }: PlatformComponentProps) => {
  const styles = useHotelsStyles(CoreHotelsComponent.HotelCard, defaultStyles);
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.HotelCard, [
    "loading",
  ]);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("carousel-container")}>
        <SkeletonLoading height="100%" />
      </div>
      <div className={cn("pre-title-container")}>
        <SkeletonLoading />
      </div>
      <div className={cn("title-container")}>
        <SkeletonLoading />
      </div>
      <div className={cn("tags-container")}>
        <SkeletonLoading />
      </div>
      <div className={cn("features-container")}>
        <SkeletonLoading />
      </div>
      <div className={cn("price-container")}>
        <SkeletonLoading />
      </div>
    </div>
  );
};
